// extracted by mini-css-extract-plugin
module.exports = {"general_error":"qqlr9l","generalError":"qqlr9l"};